import { render, staticRenderFns } from "./CameraManagementDetail.vue?vue&type=template&id=4ecdf6cc&scoped=true&"
import script from "./CameraManagementDetail.vue?vue&type=script&lang=js&"
export * from "./CameraManagementDetail.vue?vue&type=script&lang=js&"
import style0 from "./CameraManagementDetail.vue?vue&type=style&index=0&id=4ecdf6cc&scoped=true&lang=css&"
import style1 from "./CameraManagementDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecdf6cc",
  null
  
)

export default component.exports